
import gql from "graphql-tag";
import { GraphqlClient } from './GraphqlClient'
import { BlockInput } from './Types'

export const getVersionHistory = async (eventId: number, page : number) => {
	const client = GraphqlClient();
    const versionHistoryQuery = gql`
      query ($eventId: Int!, $page: Int!) {
        versionHistory (eventId: $eventId, page: $page) {
			data {
				id
				user {
					id
					firstName
					lastName
				}
				status
				changes {
					field
					description
				}
				createdAt
			}
			statusCode
			message
        }
      }
    `;
    const results = await client.query({
      query: versionHistoryQuery,
      variables: { "eventId": eventId, page},
    }); 
    return results;
};

export const getVersionHistoryCount = async (eventId: number) => {
	const client = GraphqlClient()
  
	const query = gql`
	  query ($eventId: Int!) {
		versionHistoryCount (eventId: $eventId)
	  }
	`
  
	return await client.query({ query, variables: { eventId } })
}

export const getEventComments = async (eventId: number) => {
	const client = GraphqlClient();
	const query = gql`
	  query ($eventId: Int!) {
		eventComments(eventId: $eventId) {
		  data {
			id
			eventId
			user {
			  id
			  firstName
			  lastName
			  role
			  approverLevel
			}
			message
			createdAt
		  }
		  statusCode
		  message
		  error
		}
	  }
	`;
	return await client.query({ query, variables: { eventId } });
};

export const getEventCommentsCount = async (eventId: number) => {
	const client = GraphqlClient();
	const query = gql`
	  query ($eventId: Int!) {
		eventCommentsCount(eventId: $eventId)
	  }
	`;
	return await client.query({ query, variables: { eventId } });
};

export const createEventComment = async (eventId: number, message: string) => {
	const client = GraphqlClient();
	const mutation = gql`
	  mutation ($eventId: Int!, $message: String!) {
		createEventComment(eventId: $eventId, message: $message) {
		  data {
			id
			eventId
			user {
			  id
			  firstName
			  lastName
			  role
			  approverLevel
			}
			message
			createdAt
		  }
		  statusCode
		  message
		  error
		}
	  }
	`;
	return await client.mutate({ mutation, variables: { eventId, message } });
};

export const updateEventDescription = async (id: number, description: string) => {
	
	const client = GraphqlClient();
	const EVENTINFO = gql`
		mutation ($id: Int!, $description: String!) {
			updateEventDescription (id: $id, description: $description){
				data {
					id
					description
				}
				statusCode
				message
			}
		}
	`;
	const results = await client.mutate({
		mutation: EVENTINFO,
		variables: { "id": id, "description": description },
	});
	return results;
};


export const updateEventSummary = async (id: number, summary: string) => {
	
	const client = GraphqlClient();
	const EVENTINFO = gql`
		mutation ($id: Int!, $summary: String!) {
			updateEventSummary (id: $id, summary: $summary){
				data {
					id
					summary
				}
				statusCode
				message
			}
		}
	`;
	const results = await client.mutate({
		mutation: EVENTINFO,
		variables: { "id": id, "summary": summary },
	});
	return results;
};

export const updateStaff = async (id: number, name: string, email: string, phone: string, programOffice:string, jobTitle:string) => {
	
	const client = GraphqlClient();
	const EVENTINFO = gql`
		mutation ($id: Int!, $name: String, $email: String, $phone: String, $programOffice: String, $jobTitle: String) {
			updateStaff (id: $id, name: $name, email: $email, phone: $phone, programOffice: $programOffice, jobTitle: $jobTitle){
				data {
					id
					event_id
					name
					email
					phone
					programOffice
					jobTitle
					staff_type
				}
				statusCode
				message
			}
		}
	`;
	const results = await client.mutate({
		mutation: EVENTINFO,
		variables: { "id": id, "name": name, "email": email, "phone": phone, "programOffice": programOffice, "jobTitle": jobTitle },
	});
	return results;
};

export const createStaff = async (event_id:number, staff_type:string, name: string, email: string, phone: string, programOffice:string, jobTitle:string) => {
	
	const client = GraphqlClient();
	const EVENTINFO = gql`
		mutation ($event_id: Int!, $staff_type: String, $name: String, $email: String, $phone: String, $programOffice: String, $jobTitle: String) {
			createStaff (event_id: $event_id, staff_type: $staff_type, name: $name, email: $email, phone: $phone, programOffice: $programOffice, jobTitle: $jobTitle){
				data {
					id
					event_id
					name
					email
					phone
					programOffice
					jobTitle
					staff_type
				}
				statusCode
				message
			}
		}
	`;
	const results = await client.mutate({
		mutation: EVENTINFO,
		variables: {"event_id": event_id, "staff_type": staff_type, "name": name, "email": email, "phone": phone, "programOffice": programOffice, "jobTitle": jobTitle },
	});
	return results;
};

export const updateZoomlink = async (id: number, zoomLink: string) => {
	
	const client = GraphqlClient();
	const EVENTINFO = gql`
		mutation ($id: Int!, $zoomLink: String!) {
			updateZoomlink (id: $id, zoomLink: $zoomLink){
				data {
					id
					zoomLink
				}
				statusCode
				message
			}
		}
	`;
	const results = await client.mutate({
		mutation: EVENTINFO,
		variables: { "id": id, "zoomLink": zoomLink },
	});
	return results;
};

export const blockRoom = async (eventId: number, roomId: number, input: BlockInput) => {
	const client = GraphqlClient();
	const EVENTINFO = gql`
		mutation ($eventId: Int!, $roomId: Int!, $input: BlockInput!) {
			blockRoom (eventId: $eventId, roomId: $roomId, input: $input) {
				data 
				statusCode
				message
			}
		}
	`;
    const results = await client.mutate({
	  mutation: EVENTINFO,
      variables: { "eventId": eventId, "roomId": roomId, input: input },
    }); 
    return  results;
};

export const createBlock = async (title: string, summary: string, description: string) => {
	
	const client = GraphqlClient();
	const EVENTINFO = gql`
		mutation ($title: String!, $summary: String!, $description: String!) {
			createBlock (title: $title, summary: $summary, description: $description){
				data {
					id
					title
					summary
					description
				}
				statusCode
				message
			}
		}
	`;
	const results = await client.mutate({
		mutation: EVENTINFO,
		variables: { "title": title, "summary": summary, "description": description },
	});
	return results;
};


export const allBlocked = async () => {
	const client = GraphqlClient();
    const EVENTINFO = gql`
      query  {
        allBlocked {
			data {
				id  
				date
				startTime
				endTime
				type
				category
				zoomLink
			}
			statusCode
			message
        }
      }
    `;
    const results = await client.query({
      query: EVENTINFO,
    }); 
    return  results;
};

export const sendNotification = async (id: number, additionalRequests: string) => {
  const client = GraphqlClient();
  const sendNotificationMutation = gql`
	mutation ($id: Int!, $additionalRequests: String!) {
	  sendNotification(id: $id, additionalRequests: $additionalRequests) {
		statusCode
		message
	  }
	}
  `;
  const results = await client.mutate({
	mutation: sendNotificationMutation,
	variables: { id, additionalRequests },
  });

  return results;
};

export const deleteEvent = async (id: number) => {
  const client = GraphqlClient();
  const deleteEventMutation = gql`
	mutation ($id: Int!) {
	  deleteEvent(id: $id) {
		statusCode
		message
	  }
	}
  `;
  const results = await client.mutate({
	mutation: deleteEventMutation,
	variables: { id: id },
  });

  return results;
};

export const revertVersion = async (id: number, logStatus?: boolean) => {
  const client = GraphqlClient();
  const revertVersionMutation = gql`
	mutation ($id: Int!, $logStatus: Boolean) {
	  revertVersion(id: $id, logStatus: $logStatus) {
		data {
			id
		}
		statusCode
		message
	  }
	}
  `;
  const results = await client.mutate({
	mutation: revertVersionMutation,
	variables: { id, logStatus },
  });

  return results;
};

export const approveEvent = async (id: number) => {
	const client = GraphqlClient();
	const approveEventMutation = gql`
		mutation ($id: Int!) {
			approveEvent (id: $id){
				statusCode
				message
			}
		}
	`;
	const results = await client.mutate({
		mutation: approveEventMutation,
		variables: { id },
	});
	return results;
};

export const cancelEvent = async (id: number) => {
  const client = GraphqlClient();
  const mutation = gql`
	mutation ($id: Int!) {
	  cancelEvent(id: $id) {
		statusCode
		message
	  }
	}
  `;
  const results = await client.mutate({
	mutation,
	variables: { id: id },
  });

  return results;
};
